import React, {useState, useEffect, useRef} from 'react'

export function ScrollableSelect({
  label,
  options = [],
  value,
  onChange,
  onBlur,
  name,
  errorText,
  placeholder = 'Select option',
}) {
  const [isOpen, setIsOpen] = useState(false)
  const [hovered, setHovered] = useState(null)
  const containerRef = useRef(null)

  useEffect(() => {
    const handleOutsideClick = e => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false)
        if (onBlur) onBlur()
      }
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => document.removeEventListener('mousedown', handleOutsideClick)
  }, [onBlur])

  const selected = options.find(o => o.value === value)

  return (
    <div ref={containerRef} style={{position: 'relative', width: '100%'}}>
      {label && (
        <label
          style={{
            display: 'block',
            fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
            fontSize: '12px',
            fontWeight: 500,
            color: '#374151',
            marginBottom: '4px',
          }}
        >
          {label}
        </label>
      )}
      {selected ? (
        <input
          type="text"
          value={selected.label}
          onChange={() => {}}
          onClick={() => {
            onChange('')
            setIsOpen(true)
          }}
          readOnly
          style={{
            width: '100%',
            height: '38px',
            padding: '0 12px',
            border: `1px solid ${errorText ? '#d92d20' : '#E5E7EB'}`,
            borderRadius: '6px',
            background: '#fff',
            fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
            fontSize: '14px',
            color: '#374151',
            cursor: 'text',
            boxSizing: 'border-box',
          }}
        />
      ) : (
        <div
          onClick={() => setIsOpen(o => !o)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '38px',
            padding: '0 12px',
            border: `1px solid ${errorText ? '#d92d20' : '#E5E7EB'}`,
            borderRadius: '6px',
            background: '#fff',
            fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
            cursor: 'pointer',
            color: '#b0b7c3',
            fontSize: '14px',
            userSelect: 'none',
          }}
        >
          <span>{placeholder}</span>
          <span style={{fontSize: '10px', color: '#6b7280'}}>&#9660;</span>
        </div>
      )}
      {errorText && (
        <p style={{fontSize: '12px', color: '#d92d20', margin: '4px 0 0'}}>
          {errorText}
        </p>
      )}
      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            right: 0,
            maxHeight: '220px',
            overflowY: 'auto',
            border: '1px solid #E5E7EB',
            borderRadius: '6px',
            background: '#fff',
            zIndex: 1000,
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
          }}
        >
          {options.length === 0 ? (
            <div
              style={{padding: '8px 12px', fontSize: '14px', color: '#9ca3af'}}
            >
              No options available
            </div>
          ) : (
            options.map(opt => (
              <div
                key={opt.value}
                onMouseEnter={() => setHovered(opt.value)}
                onMouseLeave={() => setHovered(null)}
                onMouseDown={e => {
                  e.preventDefault()
                  onChange(opt.value)
                  setIsOpen(false)
                }}
                style={{
                  fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
                  padding: '8px 12px',
                  fontSize: '14px',
                  cursor: 'pointer',
                  color: '#374151',
                  background:
                    value === opt.value
                      ? '#f0f0ff'
                      : hovered === opt.value
                      ? '#f9fafb'
                      : 'transparent',
                }}
              >
                {opt.label}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  )
}
